export default __webpack_public_path__ + "static/media/memberships.cb23ff5b.svg";